import { RouteUrlList } from '@/libs/RouteList';
/**
 * @todo 登入檢查
 */
const LoginViewData = [
    'POST',
    RouteUrlList.API_LoginViewData.path,
    {},
    200,
    {
        branchList: [
            {
                bid: '8840      ',
                bnm: '經紀本部       ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8841      ',
                bnm: '雙和分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8842      ',
                bnm: '新莊分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8843      ',
                bnm: '高雄分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8846      ',
                bnm: '板橋分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8847      ',
                bnm: '台南分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8848      ',
                bnm: '嘉義分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '8849      ',
                bnm: '景美分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884A      ',
                bnm: '士林分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884B      ',
                bnm: '台中分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884C      ',
                bnm: '南東分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884D      ',
                bnm: '左營分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884E      ',
                bnm: '城中分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884F      ',
                bnm: '桃園分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884H      ',
                bnm: '新竹分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884J      ',
                bnm: '大里分公司      ',
                acc: '',
                birthday: ''
            },
            {
                bid: '884M      ',
                bnm: '數位分公司      ',
                acc: '',
                birthday: ''
            }
        ],
        captchaCodeBase64Src:
            'data:image/jpeg;charset=utf-8;base64,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',
        isFidoAllow: true,
        isMOauthAllow: true,
        status: true,
        title: null,
        message: null,
        errorCode: null
    }
];

export default LoginViewData;
